import { z } from 'zod'
import { contractTemplateTypeSchema } from '@super-mega/server/contracts/contract'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

export const contractTemplateSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  ...creatorMemberSearchShape,
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  type: contractTemplateTypeSchema.optional().catch(undefined),
  status: z.enum(['enabled', 'disabled']).optional().catch(undefined)
})

declare module '@tanstack/react-router' {
  interface HistoryState {
    contractTemplateReturnSearch?: z.infer<typeof contractTemplateSearchSchema>
  }
}
